import { formatCommonDate, getPatientName } from "./formatters";

export const getInitialAssigneeComments = (items, type) =>
  items
    .map((item, index) => {
      const patientName = getPatientName(item);
      const orderDate = formatCommonDate(item.orderDate);
      const doctorName = item.patient?.doctorDetails
        ? `${item.patient.doctorDetails.firstName} ${item.patient.doctorDetails.lastName}`
        : "-";

      let details;
      if (type === "laboratory") {
        details = item.results
          ?.map((r) => `${r.testName} - ${r.value} - ${r.warning || "in range"}`)
          .join("\n");
      } else if (type === "radiology") {
        details = `Observations:\n${
          item.observations?.map((o) => `• ${o}`).join("\n") || "None"
        }`;
      } else {
        details = `Tests:\n${
          item.testNamesList?.filter(Boolean).join(", ") || "None"
        }`;
      }

      return `Patient: ${patientName}\nDate: ${orderDate}\nOrdered by: ${doctorName}\n\n${details}${
        index !== items.length - 1
          ? "\n\n----------------------------------------------"
          : ""
      }`;
    })
    .join("\n\n")
    .trim();
